/***
 * @file:
 * @author: caojianping
 * @Date: 2021-05-25 21:48:44
 */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MenuService {
  constructor() {}

  // URL change
  public selectedNode$ = new Subject<any>();

  /**
   * éä¸­çèåid
   */
  setSelected(node: object = {}, bool?: boolean) {
    this.selectedNode$.next({ node, bool });
  }
}
